// src/enums/DateFormat.ts
var DateFormatEnum = /* @__PURE__ */ ((DateFormatEnum2) => {
  DateFormatEnum2["NAMESPACE"] = "YYYY-MM-DD";
  DateFormatEnum2["ALLSCRIPTS"] = "MM/DD/YYYY";
  DateFormatEnum2["EPIC"] = "YYYY-MM-DD";
  DateFormatEnum2["CERNER"] = "YYYY-MM-DD";
  DateFormatEnum2["AMERICAN_STANDARD_DATE"] = "MM/DD/YYYY";
  return DateFormatEnum2;
})(DateFormatEnum || {});

// src/enums/npiType.ts
var npiType = /* @__PURE__ */ ((npiType2) => {
  npiType2["INDIVIDUAL"] = "INDIVIDUAL";
  npiType2["ORGANIZATION"] = "ORGANIZATION";
  return npiType2;
})(npiType || {});

// src/enums/appointmentStatus.ts
var AppointmentStatus = /* @__PURE__ */ ((AppointmentStatus2) => {
  AppointmentStatus2["ACCEPTED"] = "ACCEPTED";
  AppointmentStatus2["WAITING_FOR_PATIENT_MATCH"] = "WAITING_FOR_PATIENT_MATCH";
  AppointmentStatus2["WAITING_FOR_EHR_RESPONSE"] = "WAITING_FOR_EHR_RESPONSE";
  AppointmentStatus2["REQUESTED"] = "REQUESTED";
  AppointmentStatus2["CANCELED"] = "CANCELED";
  AppointmentStatus2["CHECKED_IN"] = "CHECKED_IN";
  AppointmentStatus2["ARCHIVED"] = "ARCHIVED";
  AppointmentStatus2["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
  AppointmentStatus2["RESCHEDULE"] = "RESCHEDULE";
  AppointmentStatus2["NO_SHOW"] = "NO_SHOW";
  AppointmentStatus2["RESENDING"] = "RESENDING";
  AppointmentStatus2["FAILED_TO_BOOK"] = "FAILED_TO_BOOK";
  AppointmentStatus2["FAILED_TO_CANCEL"] = "FAILED_TO_CANCEL";
  AppointmentStatus2["BLOCK"] = "BLOCK";
  AppointmentStatus2["NO_TCONFIRM"] = "NO TCONFIRM";
  AppointmentStatus2["READY"] = "READY";
  AppointmentStatus2["ELIGIBLE"] = "ELIGIBLE";
  AppointmentStatus2["REG"] = "REG";
  AppointmentStatus2["CONF"] = "CONF";
  AppointmentStatus2["REGD"] = "REGD";
  AppointmentStatus2["LUMACONF"] = "LUMACONF";
  AppointmentStatus2["CONFIRM"] = "CONFIRM";
  AppointmentStatus2["CX"] = "CX";
  AppointmentStatus2["RIS_CANCEL"] = "RIS Cancel";
  AppointmentStatus2["PT_R_S"] = "PT R/S";
  return AppointmentStatus2;
})(AppointmentStatus || {});

// src/enums/gender.ts
var gender = /* @__PURE__ */ ((gender2) => {
  gender2["MALE"] = "MALE";
  gender2["FEMALE"] = "FEMALE";
  gender2["UNSPECIFIED"] = "UNSPECIFIED";
  return gender2;
})(gender || {});

// src/enums/appointmentActionType.ts
var AppointmentActionType = /* @__PURE__ */ ((AppointmentActionType2) => {
  AppointmentActionType2["BOOK"] = "BOOK_APPOINTMENT";
  AppointmentActionType2["CANCEL"] = "CANCEL_APPOINTMENT";
  AppointmentActionType2["MODIFY"] = "MODIFY_APPOINTMENT";
  AppointmentActionType2["RESCHEDULE"] = "RESCHEDULE";
  AppointmentActionType2["REQUEST_TO_BOOK"] = "REQUEST_TO_BOOK";
  return AppointmentActionType2;
})(AppointmentActionType || {});

// src/enums/archiveReason.ts
var ArchiveReason = /* @__PURE__ */ ((ArchiveReason2) => {
  ArchiveReason2["NO_SHOW"] = "NOSHOW";
  ArchiveReason2["CANCELED_BY_EHR"] = "CANCELED_BY_EHR";
  ArchiveReason2["CANCELED_BY_MEMBER"] = "CANCELED_BY_MEMBER";
  return ArchiveReason2;
})(ArchiveReason || {});

// src/enums/appointmentRequestStatus.ts
var AppointmentRequestStatus = /* @__PURE__ */ ((AppointmentRequestStatus2) => {
  AppointmentRequestStatus2["REQUESTED"] = "REQUESTED";
  AppointmentRequestStatus2["BOOKED"] = "BOOKED";
  AppointmentRequestStatus2["ARCHIVED"] = "ARCHIVED";
  AppointmentRequestStatus2["UNABLE_TO_BOOK"] = "UNABLE_TO_BOOK";
  AppointmentRequestStatus2["DELIVERING"] = "DELIVERING";
  AppointmentRequestStatus2["DELIVERED"] = "DELIVERED";
  AppointmentRequestStatus2["DELIVERED_BY_PORTAL"] = "DELIVERED_BY_PORTAL";
  AppointmentRequestStatus2["OPENED"] = "OPENED";
  AppointmentRequestStatus2["FAILED_TO_SEND"] = "FAILED_TO_SEND";
  AppointmentRequestStatus2["FAILED_TO_DELIVER"] = "FAILED_TO_DELIVER";
  AppointmentRequestStatus2["WAITING_FOR_LEGAL_SIGNATURE"] = "WAITING_FOR_LEGAL_SIGNATURE";
  AppointmentRequestStatus2["OFFERED_TIMESLOTS"] = "OFFERED_TIMESLOTS";
  AppointmentRequestStatus2["TIMESLOT_SELECTED"] = "TIMESLOT_SELECTED";
  AppointmentRequestStatus2["FAILED_TO_CANCEL"] = "FAILED_TO_CANCEL";
  return AppointmentRequestStatus2;
})(AppointmentRequestStatus || {});

// src/enums/referralStatus.ts
var ReferralStatus = /* @__PURE__ */ ((ReferralStatus2) => {
  ReferralStatus2["DRAFT"] = "DRAFT";
  ReferralStatus2["SIGNED"] = "SIGNED";
  ReferralStatus2["DELETED"] = "DELETED";
  ReferralStatus2["DEFAULT"] = "DRAFT" /* DRAFT */;
  return ReferralStatus2;
})(ReferralStatus || {});

// src/enums/cancellationType.ts
var CancellationType = /* @__PURE__ */ ((CancellationType2) => {
  CancellationType2["API"] = "API";
  CancellationType2["PHONE"] = "PHONE";
  return CancellationType2;
})(CancellationType || {});

// src/enums/codingGapsStatus.ts
var CodingGapActionStatus = /* @__PURE__ */ ((CodingGapActionStatus2) => {
  CodingGapActionStatus2["AGREE"] = "AGREE";
  CodingGapActionStatus2["ADD"] = "ADD";
  CodingGapActionStatus2["DISMISS"] = "DISMISS";
  return CodingGapActionStatus2;
})(CodingGapActionStatus || {});
var CodingGapActionReason = /* @__PURE__ */ ((CodingGapActionReason2) => {
  CodingGapActionReason2["ADD"] = "ADD";
  CodingGapActionReason2["NOT_PRESENT"] = "NOT_PRESENT";
  CodingGapActionReason2["RESOLVED"] = "RESOLVED";
  CodingGapActionReason2["PENDING"] = "PENDING";
  CodingGapActionReason2["PATIENT_UNQUALIFIED"] = "PATIENT_UNQUALIFIED";
  CodingGapActionReason2["MISSING_INFO"] = "MISSING_INFO";
  CodingGapActionReason2["AGREE_NEXT_VISIT"] = "AGREE_NEXT_VISIT";
  CodingGapActionReason2["REVIEW_NEXT_VISIT"] = "REVIEW_NEXT_VISIT";
  CodingGapActionReason2["OTHER_MYCARE"] = "OTHER_MYCARE";
  CodingGapActionReason2["RESOLVED_OR_NOT_PRESENT"] = "RESOLVED_OR_NOT_PRESENT";
  CodingGapActionReason2["PENDING_ADDITIONAL_TESTING_OR_CONSULT"] = "PENDING_ADDITIONAL_TESTING_OR_CONSULT";
  CodingGapActionReason2["EVALUATE_NEXT_VISIT"] = "EVALUATE_NEXT_VISIT";
  CodingGapActionReason2["NOT_APPLICABLE"] = "NOT_APPLICABLE";
  CodingGapActionReason2["MORE_SPECIFIC_APPLICABLE"] = "MORE_SPECIFIC_APPLICABLE";
  CodingGapActionReason2["REQUIRES_MORE_INFO_OR_OTHER"] = "REQUIRES_MORE_INFO_OR_OTHER";
  CodingGapActionReason2["RESOLVED_OR_NOT_PRESENT_GENERIC"] = "RESOLVED_OR_NOT_PRESENT_GENERIC";
  CodingGapActionReason2["PENDING_ADDITIONAL_TESTING_OR_CONSULT_GENERIC"] = "PENDING_ADDITIONAL_TESTING_OR_CONSULT_GENERIC";
  CodingGapActionReason2["EVALUATE_NEXT_VISIT_GENERIC"] = "EVALUATE_NEXT_VISIT_GENERIC";
  CodingGapActionReason2["UNQUALIFIED_GENERIC"] = "UNQUALIFIED_GENERIC";
  CodingGapActionReason2["REQUIRES_MORE_INFO_OR_OTHER_GENERIC"] = "REQUIRES_MORE_INFO_OR_OTHER_GENERIC";
  CodingGapActionReason2["AGREE_WITHOUT_WRITEBACK"] = "AGREE_WITHOUT_WRITEBACK";
  CodingGapActionReason2["AUTO_RESOLVED"] = "AUTO_RESOLVED";
  return CodingGapActionReason2;
})(CodingGapActionReason || {});

// src/graphql/appointmentActions.ts
var PlatformDomains = /* @__PURE__ */ ((PlatformDomains2) => {
  PlatformDomains2["PREMERA_BLUE_CROSS_ALASKA"] = "PREMERA_BLUE_CROSS_ALASKA";
  PlatformDomains2["FLORIDA_BLUE"] = "FLORIDA_BLUE";
  PlatformDomains2["VIM"] = "VIM";
  PlatformDomains2["ANTHEM"] = "ANTHEM";
  return PlatformDomains2;
})(PlatformDomains || {});

// src/graphql/fragments/appointment.ts
import gql2 from "graphql-tag";

// src/graphql/fragments/patient.ts
import gql from "graphql-tag";
var patientFragment = gql`
  fragment patient on Patient {
    id
    firstName
    middleName
    lastName
    mobilePhoneNumber
    dateOfBirth
    memberId
    plan
    insurer
    address
    email
    gender
    vimPatientId
  }
`;

// src/graphql/fragments/appointment.ts
var fullAppointmentFragment = gql2`
  ${patientFragment}
  fragment fullAppointment on Appointment {
    id
    npi
    appointmentType
    status
    reasonForVisit
    npiType
    ehrLocationId
    ehrProviderId
    startTime
    endTime
    timezone
    patient {
      ...patient
    }
  }
`;
var patientlessAppointmentFragment = gql2`
  fragment patientlessAppointment on Appointment {
    id
    npi
    appointmentType
    status
    reasonForVisit
    npiType
    ehrLocationId
    ehrProviderId
    startTime
    endTime
    timezone
    patientId
  }
`;
var syncAppointmentFragment = gql2`
  fragment syncAppointment on Appointment {
    id
    npi
    appointmentType
    status
    reasonForVisit
    npiType
    ehrLocationId
    ehrProviderId
    startTime
    endTime
    patientId
  }
`;
var partialAppointmentFragment = gql2`
  fragment partialAppointment on MinimalAppointmentData {
    id
    status
    npi
    startTime
    endTime
  }
`;

// src/graphql/fragments/appointmentAction.ts
import gql3 from "graphql-tag";
var fullAppointmentActionFragment = gql3`
  fragment fullAppointmentAction on AppointmentAction {
    id
    memberId
    platformId
    createdAt
    updatedAt
    actionType
    status
    npi
    firstName
    middleName
    lastName
    dateOfBirth
    patientAddress
    appointmentType
    startTime
    endTime
    reasonForVisit
    ehrLocationId
    ehrProviderId
    npiType
    memberId
    plan
    insurer
    patientId
    appointmentId
    timezone
  }
`;

// src/graphql/fragments/phiFragment.ts
import gql4 from "graphql-tag";
var appointmentPhiFragment = gql4`
  fragment phiData on AppointmentPhi {
    firstName
    middleName
    lastName
    dateOfBirth
    email
    patientAddress
    reasonForVisit
    memberId
    memberIdPrefix
    gender
    plan
    phoneNumbers {
      name
      number
    }
    insurer
  }
`;
var appointmentRequestPhiFragment = gql4`
  fragment requestPhiData on AppointmentRequestPhi {
    firstName
    middleName
    lastName
    dateOfBirth
    email
    patientAddress
    reasonForVisit
    memberId
    memberIdPrefix
    gender
    plan
    phoneNumbers {
      name
      number
    }
    insurer
  }
`;

// src/graphql/provider.ts
var Location = class {
};

// src/extension/timeout-error.ts
var TimeoutError = class extends Error {
  constructor(message, properties) {
    super(message);
    Object.defineProperty(this, "name", { value: this.constructor.name });
    if (properties) {
      Object.keys(properties).forEach((key) => {
        this[key] = properties[key];
      });
    }
  }
};
export {
  AppointmentActionType,
  AppointmentRequestStatus,
  AppointmentStatus,
  ArchiveReason,
  CancellationType,
  CodingGapActionReason,
  CodingGapActionStatus,
  DateFormatEnum,
  CodingGapActionReason as DiagnosisGapActionReason,
  CodingGapActionStatus as DiagnosisGapActionStatus,
  Location,
  PlatformDomains,
  ReferralStatus,
  TimeoutError,
  appointmentPhiFragment,
  appointmentRequestPhiFragment,
  fullAppointmentActionFragment,
  fullAppointmentFragment,
  gender,
  npiType,
  partialAppointmentFragment,
  patientFragment,
  patientlessAppointmentFragment,
  syncAppointmentFragment
};
//# sourceMappingURL=index.js.map
